import React from 'react';
import { useCustomElement } from '../UseCustomElement';

export type ZuiErrorPageProps = {
  error?: '401' | '403' | '404' | '500';
  header?: string;
  subheader?: string;
  message?: string;
} & React.HTMLAttributes<HTMLElement>;

export const ZuiErrorPage = (props: ZuiErrorPageProps) => {
  const selector = 'zui-error-page';
  const customMappings = {};
  return useCustomElement(selector, props, customMappings);
};
